<script>
    import ContextualText from '../Workspaces/ElementView/ContextualText.svelte';
    import {sgettext} from '../../i18n.js';

    export let inspectionLocation = {};

    $: inspectionLocationContextualFields = [
        {
            label: sgettext('$$DISCIPLINE$$'),
            value: inspectionLocation?.classification?.discipline || ''
        },
        {
            label: sgettext('$$FUNCTIONAL_CLASS$$'),
            value: inspectionLocation?.classification?.func_class || ''
        },
        {
            label: sgettext('$$PHYSICAL_CLASS$$'),
            value: inspectionLocation?.classification?.phys_class || ''
        },
        {
            label: sgettext('$$ASSET$$'),
            value: inspectionLocation?.asset || ''
        },
        {
            label: sgettext('$$AREA$$'),
            value: inspectionLocation?.area || ''
        },
        {
            label: sgettext('$$COMPONENT$$'),
            value: inspectionLocation?.component || ''
        },
        {
            label: sgettext('$$POINT$$'),
            value: inspectionLocation?.point || ''
        }
    ]
</script>

<div class="wrapper">
    {#each inspectionLocationContextualFields as {label, value}}
        <div>
            <ContextualText><strong>{label}</strong></ContextualText>
        </div>
        <div>
            <ContextualText>{value}</ContextualText>
        </div>
    {/each}
</div>

<style>
  .wrapper {
    display: grid;
    grid-template-rows: repeat(3, auto);
    grid-template-columns: auto 1fr;
    grid-gap: 15px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
  }

  .wrapper > div {
    padding: 10px;
  }
</style>
